<template>
  <main role="main" class="col content-spacing">
    <loading-list v-if="viewData.loading"></loading-list>
    <b-container v-else>
      <b-row>
        <b-col>
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
          >
            <h1 class="h2">
              {{ viewData.id ? `Editar ${state.name}` : 'Novo Membro' }}
            </h1>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-breadcrumb
            :items="[
              {
                text: 'Lista de Membros da Cooperativa',
                href: `#/cooperative-members/${this.state.cooperative}`,
              },
              {
                text: 'Cadastro de Membro de Cooperativa',
                href: '#',
                active: true,
              },
            ]"
          ></b-breadcrumb>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-form>
              <error-container v-bind:errors="viewData.errors || []" />

              <b-form-group label="Nome">
                <b-form-input
                  v-model="state.name"
                  required
                  placeholder="Informe o nome"
                  :state="isOk('name')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('name')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="CPF/CNPJ"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.socialNumber"
                  required
                  placeholder="Informe o CPF/CNPJ"
                  :state="isOk('socialNumber')"
                  v-mask="['###.###.###-##', '##.###.###/####-##']"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('socialNumber')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Email">
                <b-form-input
                  v-model="state.email"
                  required
                  placeholder="Informe o email"
                  :state="isOk('email')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('email')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Telefone"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.phone"
                  required
                  placeholder="Informe o Telefone"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                  :state="isOk('phone')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('phone')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Data Início"
                label-for="input-1"
              >
                <b-form-datepicker
                  :state="isOk('startDate')"
                  id="example-datepicker-beg"
                  placeholder="Selecione uma data"
                  v-model="state.startDate"
                  class="mb-2"
                ></b-form-datepicker>
                <b-form-invalid-feedback>{{
                  getError('startDate')
                }}</b-form-invalid-feedback>

                <b-form-invalid-feedback>{{
                  getError('startDate')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-2"
                label="Data Fim"
                label-for="input-1"
              >
                <b-form-datepicker
                  :state="isOk('endDate')"
                  id="example-datepicker-end"
                  placeholder="Selecione uma data"
                  v-model="state.endDate"
                  class="mb-2"
                ></b-form-datepicker>
                <b-form-invalid-feedback>{{
                  getError('endDate')
                }}</b-form-invalid-feedback>

                <b-form-invalid-feedback>{{
                  getError('endDate')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Estado Civil">
                <b-form-select
                  v-model="state.maritalStatus"
                  :options="maritialStatus"
                ></b-form-select>
              </b-form-group>

              <b-form-group label="Nacionalidade">
                <b-form-input
                  v-model="state.nationality"
                  required
                  placeholder="Informe o Nacionalidade"
                  :state="isOk('nationality')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('nationality')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Profissão">
                <b-form-input
                  v-model="state.profession"
                  required
                  placeholder="Informe a Profissão"
                  :state="isOk('profession')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('profession')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <submit-button
                v-bind:action="() => save()"
                v-bind:label="'Salvar'"
              ></submit-button>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';

const API = new Api();

export default {
  name: 'cooperative-members-edit',
  data: function() {
    return {
      maritialStatus: [
        { value: 'single', text: 'Solteiro(a)' },
        { value: 'married', text: 'Casado(a)' },
        { value: 'divorced', text: 'Viúvo(a)' },
      ],
      state: {
        name: '',
        socialNumber: '',
        createdAt: null,
        updatedAt: null,
        email: '',
        phone: '',
        startDate: null,
        endDate: null,
        nationality: '',
        maritalStatus: '',
        profession: '',
        cooperative: 0,
      },
      viewData: {
        id: 0,
        loading: false,
        errors: [],
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    let isNew = this.$route.path.includes('new');
    const _id = this.$route.params && !isNew ? this.$route.params.id : 0;

    this.state.cooperative = isNew
      ? this.$route.params.id
      : this.$route.params.idCoop;

    if (_id) {
      this.viewData.id = _id;

      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/cooperative-members/' + _id,
          method: 'get',
        });

        this.state = { ...result.model, cooperative: this.state.cooperative };
        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    }
  },
  methods: {
    getError(property) {
      return helpers.getError(this.viewData.errors, property);
    },
    isOk(property) {
      let hasError = helpers.hasError(this.viewData.errors, property);
      if (hasError) {
        return false;
      }
    },
    updateUrl(url) {
      this.state.url = url;
    },
    setLoadingPhoto(loading) {
      this.viewData.loadingPhoto = loading;
    },
    async save() {
      try {
        let data = _.cloneDeep(this.state);
        data.socialNumber = _.replace(data.socialNumber, '.', '');
        data.socialNumber = data.socialNumber
          .replace(/\./g, '')
          .replace(/\-/g, '')
          .replace(/\//g, '');

        const result = await API.post('/execute', {
          path: this.viewData.id
            ? `/cooperative-members/${this.viewData.id}`
            : '/cooperative-members/',
          method: this.viewData.id ? 'put' : 'post',
          data: data,
        });

        this.$toast.success('Cooperativa incluída com sucesso');

        this.$router.push(`/cooperative-members/${this.state.cooperative}`);
      } catch (ex) {
        this.viewData.errors = helpers.getErrors(ex);
      }
    },
  },
  components: {
    'image-upload': require('../image-upload.vue').default,
  },
};
</script>
